import React, {useEffect, useState} from "react"
import { useNavigate } from "react-router-dom"

import "./WebTest.css"
import {getMin, getMinSec, retrieveData, sendRequest} from "../../common";
import app from "../../App";

function WebTestComplete() {

	const navigate = useNavigate()

	const [applyTest, setApplyTest] = useState()
	const [time, setTime] = useState()

	useEffect(() => {
		retrieveData('applyTest').then(applyTest => {
			setApplyTest(applyTest)
		})

		retrieveData('startTime').then(startTime => {
			setTime(new Date().getTime() - startTime)
		})
	}, [])

	useEffect(() => {
		sendRequest(`test/apply-test/${applyTest?.id}/`, 'PUT', {
			isDone: true,
			doneDateTime: new Date()
		})
	}, [applyTest])

	return (
		<>
			<div className="webContainer">
				<section className="testComplete">
					<h2>검사 완료 안내</h2>
					<div className="info">
						<p>
						모든 검사가 완료되었습니다.<br />
						최종 검사결과는 분석사의 해석과 함께 안내됩니다.
						</p>
						<span>
						검사 진행 시간 : {getMin(time / 1000)}분
						</span>
					</div>
					<div className="buttonWrap">
						<button
							className="submitBtn"
							type="submit"
							onClick={() => {
								navigate("/")
							}}>
							홈으로 돌아가기
						</button>
					</div>
				</section>
			</div>
		</>
	)
}

export default WebTestComplete
